import { z } from "zod";
import { ProductSchema } from "@/core/products/schemas/ProductSchema";

export const localProductSchema = z.object({
  ...ProductSchema.shape,
  code: z.string().min(1, "Debe tener al menos 1 caracter"),
  comment: z.string(),
  purchasePrice: z.coerce.number().min(0, "Debe ser mayor o igual a 0"),
  maximumStock: z.coerce.number().min(0, "Debe ser mayor o igual a 0"),
  zoneId: z.string().min(1, "Debe seleccionar una zona"),
  images: z
    .array(z.instanceof(File).or(z.string().url()))
    .optional()
    .default([]),
});

export type LocalProductFormInput = z.infer<typeof localProductSchema>;
